import { render, staticRenderFns } from "./WeatherIcon.vue?vue&type=template&id=21227334&lang=pug"
import script from "./WeatherIcon.vue?vue&type=script&lang=js"
export * from "./WeatherIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports